import { NavLink } from 'react-router'
import styled from 'styled-components'

import { Typography, useHapticFeedback } from '@blade/ui-kit'

import type { IconProps } from '@root/shared/ui-kit'

type BottomNavigationItemProps = {
  icon: React.FC<IconProps>
  title: React.ReactNode
  active?: boolean
  onClick?: () => void
  to?: string
}

export const BottomNavigationItem: React.FC<BottomNavigationItemProps> = ({
  icon,
  title,
  active,
  onClick,
  to,
}) => {
  const haptics = useHapticFeedback()

  const Icon = icon

  const renderContent = () => {
    return (
      <>
        <Icon size={18} />
        <Title>{title}</Title>
      </>
    )
  }

  if (to) {
    return (
      <Root
        as={NavLink}
        to={to}
        type="button"
        onClick={() => {
          haptics.impactOccurred('light')
        }}
        data-active={active}
      >
        {renderContent()}
      </Root>
    )
  }

  return (
    <Root type="button" onClick={onClick} data-active={active}>
      {renderContent()}
    </Root>
  )
}

const Title = styled(Typography).attrs({
  variant: 'body5-semi-bold',
  component: 'div',
})`
  text-align: center;
`

const Root = styled.button`
  all: unset;
  position: relative;
  display: grid;
  gap: 2px;
  justify-items: center;
  color: var(--text-9);
  cursor: pointer;

  &[data-active='true'],
  &.active {
    color: var(--text-11);
    svg {
      color: var(--primary-9);
    }

    &::after {
      content: '';
      position: absolute;
      top: -14px;
      left: 0;
      width: 100%;
      height: 100%;
      border-top: 2px solid var(--primary-9);
    }
  }
`
